import { Button } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { ImagePicker } from "../../../Shared/useImageCrop/ImagePicker";
import RichTextEditorCustom from "../../../Shared/CustomRichTextEditor";

export default function Newsupdate() {
  const [title, setTitle] = useState("");
  const [metaKeyword, setMetaKeyword] = useState("");
  const [metaDescription, setMetaDescription] = useState("");
  const [content, setContent] = useState("");
  const [data, setData] = useState([]);
  const [image, setImage] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();

  const { state } = useLocation();

  const addnews = (event) => {
    event.preventDefault();
    const reqbody = new FormData();
    reqbody.append("Title", title);
    reqbody.append("meta_keyword", metaKeyword);
    reqbody.append("meta_description", metaDescription);
    reqbody.append("Content", content);
    image && reqbody.append("images", image);

    axios
      .put(
        `https://m1blog.aaragroups.com/blog/api/admin/api/news_deatils_api/?id=${id}`,
        reqbody,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            token: localStorage.getItem("token"),
          },
        },
      )
      .then((response) => {
        toast.success(response.data.message);
        navigate("/news");
      })
      .catch(() => {
        toast.error("Some error occurred");
      });
  };

  useEffect(() => {
    if (state) {
      handleEdit(state);
    }
  }, [state]);

  const handleEdit = (prevData) => {
    setTitle(prevData?.Title || "");
    setMetaDescription(prevData?.meta_description || "");
    setMetaKeyword(prevData?.meta_keyword || "");
    setContent(prevData?.content || "");
  };

  return (
    <div className="flex flex-col w-full min-h-screen bg-gray-100 p-4">
      <div className="max-w-5xl w-full mx-auto bg-white shadow-lg rounded-lg p-6">
        <p className="text-2xl font-bold text-center border-b-2 border-gray-300 pb-3 mb-6">
          Update News
        </p>

        <form onSubmit={addnews} className="space-y-6">
          {/* Title */}
          <div className="flex flex-col">
            <label className="text-sm font-semibold mb-1">Title</label>
            <input
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Enter title"
              className="w-full p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
          </div>

          {/* Meta Description */}
          <div className="flex flex-col">
            <label className="text-sm font-semibold mb-1">
              Meta Description
            </label>
            <input
              value={metaDescription}
              onChange={(e) => setMetaDescription(e.target.value)}
              placeholder="Enter meta description"
              className="w-full p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
          </div>

          {/* Meta Keyword */}
          <div className="flex flex-col">
            <label className="text-sm font-semibold mb-1">Meta Keyword</label>
            <input
              value={metaKeyword}
              onChange={(e) => setMetaKeyword(e.target.value)}
              placeholder="Enter meta keywords"
              className="w-full p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
          </div>

          {/* Image */}
          <div className="flex flex-col">
            <label className="text-sm font-semibold mb-1">Image</label>
            <ImagePicker placeholder="Choose Image" handleChange={setImage} />
          </div>

          {/* Content */}
          <div className="flex flex-col">
            <label className="text-sm font-semibold mb-1">Content</label>
            <RichTextEditorCustom
              value={content}
              className="h-60 mb-3 border border-gray-300 rounded"
              onChange={(value) => setContent(value)}
            />
          </div>

          {/* Submit Button */}
          <div className="flex justify-center">
            <Button type="submit" variant="contained" size="large">
              Update News
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
